const channels = [
  {
    id: 1,
    name: 'Easy French',
    url: 'https://www.youtube.com/@EasyFrench',
    videos: [
      'https://www.youtube.com/watch?v=nzbPRKib3ZQ',
      'https://www.youtube.com/watch?v=xL1c6ZEO8O4'
    ]
  },
  {
    id: 2,
    name: 'Learn French with FrenchPod101.com',
    url: 'https://www.youtube.com/user/frenchpod101',
    videos: [
      'https://www.youtube.com/watch?v=KM8wK4UIS2k'
    ]
  },
  {
    id: 3,
    name: 'Learn French With Alexa',
    url: 'https://www.youtube.com/c/learnfrenchwithalexa',
    videos: [
      'https://www.youtube.com/watch?v=vCUavSqvgPo'
    ]
  },
  {
    id: 4,
    name: 'Français avec Pierre',
    url: 'https://www.youtube.com/c/FrancaisavecPierre',
    videos: [
      'https://www.youtube.com/watch?v=ZLTVf1AurIM'
    ]
  },
  {
    id: 5,
    name: 'LEARN FRENCH WITH VINCENT',
    url: 'https://www.youtube.com/c/imagiers',
    videos: [
      'https://www.youtube.com/watch?v=cWqfvZEe8d4'
    ]
  },
  {
    id: 6,
    name: 'French Classes from LogicLanguageLearning',
    url: 'https://www.youtube.com/channel/UCR062I8ifJV0LdwoAXvJjUw/',
    videos: [
      'https://www.youtube.com/watch?v=BCCIuZMlNEY',
      'https://www.youtube.com/watch?v=ERvCxYZCqjk',
      'https://www.youtube.com/watch?v=umyumFQM08Y'
    ],
    profileLinks: [
      {
        'label': 'Go to my website!',
        'url': 'https://logiclanguagelearn.wixsite.com/logiclanguage/testimonials'
      }
    ]
  }
]

export default channels


// WEBPACK FOOTER //
// ./src/browser/channels/languages/french.js